@if (showBar) {
    <div class="attribution-bar">
        <span class="attribution-bar__savings" translate="cart.attribution.bar.savings"
            [interpolate]="{name: sponsorDisplayName}"></span>
        @if (isRetail) {
            <a class="attribution-bar__change" (click)="openSponsorChangeModal()"
               translate="cart.attribution.bar.change"></a>
        }
    </div>
}

